import type { MessageDescriptor } from 'react-intl'
import { defineMessages } from 'react-intl'

interface BaseLoyaltyCampaignOffer {
  title: MessageDescriptor
  description: MessageDescriptor
  link: string
  imageId: string
  /** If specified, offer only shows in these regions. If omitted, shows in all regions. */
  regions?: Array<string>
}

/**
 * Campaign offer controlled by custom rule (shows only when rule is active)
 * Can specify multiple rule IDs (e.g., one for staging, one for prod)
 */
interface RuleBasedCampaignOffer extends BaseLoyaltyCampaignOffer {
  customRuleIds: Array<string>
}

/**
 * Campaign offer that is always enabled (not tied to custom rules)
 */
interface AlwaysEnabledCampaignOffer extends BaseLoyaltyCampaignOffer {
  forceEnable: true
}

export type LoyaltyCampaignOffer = RuleBasedCampaignOffer | AlwaysEnabledCampaignOffer

const messages = defineMessages({
  doublePointsUltraLuxTitle: {
    id: '3E6rLHIGnoYLv6jHurhY',
    defaultMessage: 'Double Points on Ultra Lux escapes',
    description: 'Campaign offer title for double points on Ultra Lux bookings',
  },
  doublePointsUltraLuxDescription: {
    id: 'lX-ByK4Oo2schlzQs2ig',
    defaultMessage: 'When only the best will do. Book from our Ultra Lux collection and earn Double Points.',
    description: 'Campaign offer description for double points on Ultra Lux bookings',
  },
})

export const LOYALTY_CAMPAIGN_OFFERS: Array<LoyaltyCampaignOffer> = [
  {
    title: messages.doublePointsUltraLuxTitle,
    description: messages.doublePointsUltraLuxDescription,
    link: '/ultra-lux',
    imageId: 'gkc3cki0fnhpxzswubv',
    customRuleIds: [
      '628c9023-0529-4547-beba-f101928245cf',
      // prod rule id
      'bdfe3e73-b208-4d20-9d36-ef1a64c65945',
    ],
  },
]
